import { useInfiniteQuery } from "@tanstack/react-query";
import { listThreads } from "../lib/api-client";
import { mailboxQueryKeys } from "../lib/query-keys";

export function useThreads(mailboxId: string | undefined, folderSlug: string) {
  return useInfiniteQuery({
    queryKey: mailboxQueryKeys.threads(mailboxId ?? "", folderSlug),
    queryFn: ({ pageParam }) => listThreads(mailboxId!, folderSlug, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled: Boolean(mailboxId),
    staleTime: 15_000,
  });
}
